

import React, { Component } from 'react';
import OpenNewWindowIcon from 'Components/icons/OpenNewWindowIcon/OpenNewWindowIcon.jsx';
export class AgOpenInNewTab extends Component {
    constructor(props) {
        super(props);
        this.invokeParentMethod = this.invokeParentMethod.bind(this);

    }

    render() {
        return (
            <span>
                <OpenNewWindowIcon onClick={this.invokeParentMethod} 
                height={20} width={20}  
                />
            </span>
        );
    }

    invokeParentMethod(rowIndex, keySeqKey) {

        this.props && this.props.context && this.props.context.componentParent && this.props.context.componentParent.props && this.props.context.componentParent.props.rowActionClick && this.props.context.componentParent.props.rowActionClick(this.props.node.rowIndex, 'OPEN_CASE_IN_TAB');
    };
}
export default AgOpenInNewTab;